import axios from '~/utils/axios';

export type PricingFeeType =
  | 'fixedDebitFee'
  | 'fixedDebitFeeDecrease'
  | 'percentDebitFee'
  | 'percentDebitFeeDecrease'
  | 'fixedCreditFee'
  | 'percentCreditFee'
  | 'tieredDebitFee'
  | 'tieredCreditFee'
  | 'counterBasedDebitFee'
  | 'counterBasedCreditFee'
  | 'fixedPlusPercentDebitFee'
  | 'fixedPlusPercentCreditFee';

export type FeeLoyaltyDiscountType = 'FULL' | 'PERCENT' | 'FIXED';

export type AcquiringFeeType =
  | 'FIXED_INCREASE'
  | 'FIXED_DECREASE'
  | 'PERCENT_INCREASE'
  | 'PERCENT_DECREASE';

export type PricingSchemaPropertie = {
  type:
    | 'veengu_fee_membership'
    | 'veengu_fee_default'
    | 'veengu_fee_acquiring'
    | 'veengu_service_charges'
    | 'veengu_fee_loyalty_default'
    | 'veengu_limit_default_amount'
    | 'veengu_limit_default_count'
    | 'veengu_limit_single_operation_amount'
    | 'veengu_tax_default';
  'v:category':
    | 'fee'
    | 'loyalty'
    | 'limit'
    | 'counter'
    | 'interest'
    | 'service'
    | 'tax'
    | 'earnings';
  'v:feature': string;
  'v:name': string;
  'v:index'?: number;
  'v:default'?: any;
  'v:enum'?: {
    id: PricingFeeType | AcquiringFeeType;
    name: string;
  }[];
};

export type PricingSchema = {
  type: string;
  required: string[];
  properties: {
    [x: string]: PricingSchemaPropertie;
  };
};

export type PricingSchemaParams = {
  productId?: string;
  externalSourceType?: string;
  pricingFormat?: string;
};

export const getPricingSchema = (params: PricingSchemaParams) => {
  return axios.get<PricingSchema>('/pricings/schema', { params });
};
